export default "__VITE_PUBLIC_ASSET__86bc9b2a__"